import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
// import parse from 'html-react-parser'

// Components
import Header from './header';

const Layout = ({ isHomePage, children }) => {
  const {
    wp: {
      generalSettings: { title },
    },
  } = useStaticQuery(graphql`
    query LayoutQuery {
      wp {
        generalSettings {
          title
          description
        }
      }
    }
  `);

  return (
    <div className="global-wrapper" data-is-root-path={isHomePage}>
      <Header title={title} />

      {children}
    </div>
  );
};

export default Layout;
